module.exports = __webpack_public_path__ + "img/bg3-1.05ad76d5.png";